(function () {
  var allHotspots = document.querySelectorAll('.reg-hotspot');
  var MOBILE_BREAKPOINT = 767;
  var mobilePlaceholder = null;
  var mobileHotspot = null;
  var mobileTip = null;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function closeAll() {
    allHotspots.forEach(function (hs) {
      hs.classList.remove('is-active');
      var btn = hs.querySelector('.reg-hotspot__dot');
      var tip = hs.querySelector('.reg-hotspot__tooltip');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (tip) tip.classList.remove('is-open');
    });

    /* Return a mobile tooltip to its original hotspot without leaving a visual frame. */
    if (mobilePlaceholder && mobileHotspot && mobileTip) {
      var tip = mobileTip;

      /* Hide it BEFORE moving it back into the map. This prevents the
         browser from briefly painting the tooltip in its old position. */
      tip.style.display = 'none';
      tip.style.visibility = 'hidden';
      tip.classList.remove(
        'reg-hotspot__tooltip--viewport',
        'reg-hotspot__tooltip--viewport-below',
        'is-open'
      );
      tip.style.removeProperty('--tooltip-left');
      tip.style.removeProperty('--tooltip-top');
      tip.style.removeProperty('--arrow-left');

      if (mobilePlaceholder.parentNode) {
        mobilePlaceholder.parentNode.insertBefore(tip, mobilePlaceholder.nextSibling);
      }

      /* Keep the closed state explicit. The normal CSS also has display:none,
         but this avoids a one-frame flash caused by the DOM move. */
      tip.style.display = 'none';
      tip.style.visibility = '';

      mobilePlaceholder.remove();
      mobilePlaceholder = null;
      mobileHotspot = null;
      mobileTip = null;
    }
  }

  function positionDesktopTooltip(hotspot) {
    var rect = hotspot.getBoundingClientRect();
    var mapRect = hotspot.closest('.reg-map-wrapper').getBoundingClientRect();

    var relTop = rect.top - mapRect.top;
    if (relTop < 120) {
      hotspot.classList.add('tooltip--below');
    } else {
      hotspot.classList.remove('tooltip--below');
    }

    var relLeft = rect.left - mapRect.left;
    var mapWidth = mapRect.width;
    if (relLeft > mapWidth * 0.65) {
      hotspot.classList.add('tooltip--left');
    } else {
      hotspot.classList.remove('tooltip--left');
    }
  }

  function positionMobileTooltip(hotspot, tip) {
    var dot = hotspot.querySelector('.reg-hotspot__dot');
    var dotRect = dot.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = document.documentElement.clientHeight;
    var margin = viewportWidth <= 420 ? 10 : 12;

    /* Make the card measurable before calculating its final position. */
    tip.classList.add('reg-hotspot__tooltip--viewport');
    tip.style.visibility = 'hidden';
    tip.style.display = 'block';
    tip.style.left = '0px';
    tip.style.top = '0px';

    var tipRect = tip.getBoundingClientRect();
    var tipWidth = Math.min(tipRect.width || (viewportWidth - margin * 2), viewportWidth - margin * 2);
    var tipHeight = tipRect.height;

    /* Center the card on the pin first. */
    var left = dotRect.left + dotRect.width / 2 - tipWidth / 2;
    left = Math.max(margin, Math.min(left, viewportWidth - margin - tipWidth));

    /* Prefer above the pin, exactly like the desktop behavior. */
    var gap = 10;
    var topAbove = dotRect.top - tipHeight - gap;
    var topBelow = dotRect.bottom + gap;
    var top;
    var below = false;

    if (topAbove >= margin) {
      top = topAbove;
    } else if (topBelow + tipHeight <= viewportHeight - margin) {
      top = topBelow;
      below = true;
    } else {
      /* If neither side fits, keep the entire card inside the viewport. */
      top = Math.max(margin, Math.min(topAbove, viewportHeight - margin - tipHeight));
      if (top > dotRect.top) below = true;
    }

    /* Arrow points at the pin even when the card is edge-aligned. */
    var arrowLeft = dotRect.left + dotRect.width / 2 - left;
    arrowLeft = Math.max(18, Math.min(arrowLeft, tipWidth - 18));

    tip.style.setProperty('--tooltip-left', Math.round(left) + 'px');
    tip.style.setProperty('--tooltip-top', Math.round(top) + 'px');
    tip.style.setProperty('--arrow-left', Math.round(arrowLeft) + 'px');
    tip.classList.toggle('reg-hotspot__tooltip--viewport-below', below);
    tip.style.visibility = 'visible';
  }

  function openMobileTooltip(hotspot, tip, btn) {
    /* Close any existing tooltip before moving this one. */
    closeAll();

    hotspot.classList.add('is-active');
    mobileHotspot = hotspot;
    mobileTip = tip;
    mobilePlaceholder = document.createComment('mobile-tooltip-placeholder');
    tip.parentNode.insertBefore(mobilePlaceholder, tip);
    document.body.appendChild(tip);

    tip.classList.add('reg-hotspot__tooltip--viewport');
    tip.classList.add('is-open');
    tip.style.display = 'block';
    tip.style.visibility = 'hidden';
    btn.setAttribute('aria-expanded', 'true');

    positionMobileTooltip(hotspot, tip);
  }

  function initMap() {
    allHotspots = document.querySelectorAll('.reg-hotspot');

    allHotspots.forEach(function (hotspot) {
      var btn = hotspot.querySelector('.reg-hotspot__dot');
      var tip = hotspot.querySelector('.reg-hotspot__tooltip');
      if (!btn || !tip) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        var isOpen = tip.classList.contains('is-open');
        closeAll();
        if (isOpen) return;

        if (isMobile()) {
          openMobileTooltip(hotspot, tip, btn);
        } else {
          positionDesktopTooltip(hotspot);
          hotspot.classList.add('is-active');
          tip.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      tip.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', closeAll);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    /* Recalculate an open mobile card after rotation/resize. */
    window.addEventListener('resize', function () {
      if (mobileHotspot && isMobile()) {
        var tip = document.querySelector('.reg-hotspot__tooltip--viewport');
        if (tip) positionMobileTooltip(mobileHotspot, tip);
      } else if (mobileHotspot && !isMobile()) {
        closeAll();
      }
    });

    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        if (mobileHotspot && isMobile()) {
          var tip = document.querySelector('.reg-hotspot__tooltip--viewport');
          if (tip) positionMobileTooltip(mobileHotspot, tip);
        }
      }, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMap);
  } else {
    initMap();
  }
})();
